module.exports = __webpack_public_path__ + "img/delete-icon.1d54da5b.svg";